import React from 'react';
import { DocumentAnalyzeEmptyState } from './DocumentAnalyzeEmptyState';
import { LocationsEmptyIllustration } from './empty-illustration';

interface LocationsEmptyStateProps {
  canEdit: boolean;
  onAdd: () => void;
  onAnalyze: () => void;
  isAnalyzing: boolean;
  analyzeDisabled: boolean;
  analyzeTooltip?: string;
}

export const LocationsEmptyState: React.FC<LocationsEmptyStateProps> = ({
  canEdit,
  onAdd,
  onAnalyze,
  isAnalyzing,
  analyzeDisabled,
  analyzeTooltip,
}) => {
  return (
    <DocumentAnalyzeEmptyState
      illustration={<LocationsEmptyIllustration />}
      titleKey="locations_empty_title"
      descriptionKey="locations_empty_description"
      addLabelKey="add_location"
      analyzeLabelKey="analyze_locations_from_document"
      canEdit={canEdit}
      onAdd={onAdd}
      onAnalyze={onAnalyze}
      isAnalyzing={isAnalyzing}
      analyzeDisabled={analyzeDisabled}
      analyzeTooltip={analyzeTooltip}
    />
  );
};
